import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicalCross: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMedicalCross"><Path d="M13.5 2C14.8807 2 16 3.11929 16 4.5V6.5C16 7.32843 16.6716 8 17.5 8H19.5C20.8807 8 22 9.11929 22 10.5V13.5C22 14.8807 20.8807 16 19.5 16H17.5C16.6716 16 16 16.6716 16 17.5V19.5C16 20.8807 14.8807 22 13.5 22H10.5C9.11929 22 8 20.8807 8 19.5V17.5C8 16.6716 7.32843 16 6.5 16H4.5C3.11929 16 2 14.8807 2 13.5V10.5C2 9.11929 3.11929 8 4.5 8H6.5C7.32843 8 8 7.32843 8 6.5V4.5C8 3.11929 9.11929 2 10.5 2H13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicalCross;
